import styled from 'styled-components/macro';
import { colorCoreGray300, colorCoreWhite1000 } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
import { elevationBottomLvl2 } from '@yme/tokens/elevations';
export const WrapperStyled = styled.button `
  box-sizing: border-box;
  display: flex;
  border: none;
  justify-content: center;
  align-items: center;
  height: ${({ size }) => size};
  width: ${({ size }) => size};
  border-radius: ${CORNER_RADIUS.circle};
  background: ${colorCoreWhite1000};
  box-shadow: ${elevationBottomLvl2};

  &:hover {
    cursor: pointer;
    background-color: ${colorCoreGray300};
  }
`;
